import { render, staticRenderFns } from "./PayrollAnalytics.vue?vue&type=template&id=61cc346b"
import script from "./PayrollAnalytics.vue?vue&type=script&lang=js"
export * from "./PayrollAnalytics.vue?vue&type=script&lang=js"
import style0 from "./PayrollAnalytics.vue?vue&type=style&index=0&id=61cc346b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports